import { render, staticRenderFns } from "./addGoodsToStore.vue?vue&type=template&id=453d2a9c"
import script from "./addGoodsToStore.vue?vue&type=script&lang=js"
export * from "./addGoodsToStore.vue?vue&type=script&lang=js"
import style0 from "./addGoodsToStore.vue?vue&type=style&index=0&id=453d2a9c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('453d2a9c')) {
      api.createRecord('453d2a9c', component.options)
    } else {
      api.reload('453d2a9c', component.options)
    }
    module.hot.accept("./addGoodsToStore.vue?vue&type=template&id=453d2a9c", function () {
      api.rerender('453d2a9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/publishProduct/addGoodsToStore.vue"
export default component.exports